import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_22134_7019)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M30.3567 15.1633C31.0017 15.82 30.9917 16.875 30.3333 17.52L22.9567 24.7617C21.6517 26.0417 19.9717 26.68 18.29 26.68C16.6267 26.68 14.9633 26.0533 13.6633 24.7983L10.4983 21.6867C9.84167 21.0417 9.83333 19.9867 10.4783 19.33C11.1217 18.6717 12.18 18.6633 12.835 19.31L15.99 22.4117C17.2833 23.6617 19.325 23.655 20.625 22.3817L28 15.1417C28.655 14.495 29.7067 14.5067 30.3567 15.1633ZM40 20C40 31.0283 31.0283 40 20 40C8.97167 40 0 31.0283 0 20C0 8.97167 8.97167 0 20 0C31.0283 0 40 8.97167 40 20ZM36.6667 20C36.6667 10.81 29.19 3.33333 20 3.33333C10.81 3.33333 3.33333 10.81 3.33333 20C3.33333 29.19 10.81 36.6667 20 36.6667C29.19 36.6667 36.6667 29.19 36.6667 20Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22134_7019",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgSuccess;
